
import {  Component,FormPageMixins,appConst } from "@/lib";
import DeclareCustoms from "@/store/modules/shipment/declarecustoms/entity";
import CustomsBox from "@/store/modules/shipment/declarecustoms/customsbox"
@Component
export default class CreateDeclareCustomsView extends FormPageMixins {
  model:DeclareCustoms = new DeclareCustoms();
  loading: boolean = false;

  async created() {

            Object.assign(this.config,{
            getAction:"shipment/declarecustoms/get",
             labelWidth:220,
            pageTitleL:"Action.Edit",
            okAction:"shipment/declarecustoms/create",
            isRedirectIndex:false,
            isHideOk: true

        })
  this.$store.dispatch("system/logistics/getIsTraileLogisticsList");
  }
    get record(){ 
      var tt=this.$store.state.shipment.declarecustoms.editDeclareCustoms;
      tt.shippingNumber='';
      tt.receiverAmount='';
      return tt
    };
      //状态
  get businessGroupList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.businessGroup)
  }
    //状态
  get shippingTypeList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.shippingType)
  }
    get transactionList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.transaction)
  }
    get startPortList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.startPort)
  }
    get endPortList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.endPort)
  }
    get countryOfArrivalList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.countryOfArrival)
  }
    get tradingCountryList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.tradingCountry)
  }
    get paymentList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.payment)
  }
  get salesTypeList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.salesType)
  }
//货代
  get logisticsList() {
    return this.$store.state.system.logistics.logisticsList;
  }
  //客户列表
  get customerList() {
  
    var tt=this.$store.state.system.customer.customerList;
    return tt
  }

        //发货人列表
  get senderList() {
    return this.$store.state.system.sender.senderList;
  }

        //箱型
  get boxTypeList() {
      return this.getCodeListByCategory(
      appConst.codeCategory.boxType)
  }
   async getpayment(value) {
   
     let response =  await this.$store.dispatch({
            type: "shipment/declarecustoms/getPayment",
            id: value,
          });
          this.$set(this.model,"payment",response)
  }
    openDeclareGroupInfo(value) {     
         this.$router.push({
      name: "declareCustoms.declareGroup",
      query: {id:value}
      ,
    });
    }
     invoiceRatioValidator(index) {
        return [
        {required: true, type:'string', message: this.L('app.CustomsDeclarationElement.PleaseInput',this.L('app.DeclareCustoms.BoxTypeQuantity')), trigger: 'blur'},
        {type: "string", validator: (rule:any, value:any, callback:any) => {
            const message = "请输入箱型/箱量";
            const messagelogistics = "请选择拖车货代";
         //   let invoiceTypeOfCurrentIndex = this.model.customsBoxList[index].boxType;
            // if (this.model.customsBoxList.findIndex((item, itemIndex)=>{ return item.boxType === invoiceTypeOfCurrentIndex && item.boxQuantity == value && itemIndex !== index}) !== -1) {
            //     callback(new Error(`${this.L('app.DeclareCustoms.BoxTypeQuantity')}${this.L('app.CustomsDeclarationElement.CanNotBeRepeat')}`));
            //     return;
            // }
            if (!this.model.customsBoxList[index].boxQuantity) {
                callback(message);
                return;
            }
             if (!this.model.customsBoxList[index].logisticsId&&this.model.customsBoxList[index].boxType!='LCL') {
                callback(messagelogistics);
                return;
            }
            callback();
        }, trigger: 'blur,change'}
        ]
    }

    elementInput(index) {
        (this.$refs["form-modal"] as any).validateField('customsBoxList.' + index + '.boxType')
    }
     addElement() {
        this.model.customsBoxList.push(new CustomsBox);
    }
      get currentUser() {
    return this.$store.state.currentUser.session.user;
  }
 removeInvoice(index) {
    if (this.model.customsBoxList.length > 1) {
      let temp=new Array<CustomsBox>();
      this.model.customsBoxList.forEach((element,idx) => {
        if(idx!==index){
          temp.push(element)
        }
       
      });
      this.model.customsBoxList=temp;
    }
 }

  ok() {
    let self = this;
    (this.$refs["form-page"] as any).formValidate(async (model: any) => {
      self.loading = true;
      self.model.createType = appConst.declareCustomsCreateType.copy;
      self.model.copySourceId = Number(self.$route.query.id);
      self.model.id = undefined;
      let result = await self.$store.dispatch({ type: self.config.okAction, data: self.model }).finally(() => {
        self.loading = false;
      });
      
      self.$Message.success(self.L("Tip.SavedSuccessfully"));
      self.$router.push({name: "declareCustoms.declareGroup", query: {id: result.id}});
    });
  }

  formatTotalVolume(value: string): string {
    if (!value && value !== '0') return '';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    const fixed = num.toFixed(3);
    return fixed.endsWith('0') ? num.toFixed(2) : fixed;
  }

  parseTotalVolume(value: string): string {
    return (value || '').replace(/,/g, '');
  }
}

